// DarkModeContext.jsx
//
// Backwards-compatibility shim. The MUI theme provider is now owned by
// `SettingsProvider` in `setting/SettingsContext.js`, which exposes mode
// + presets + font family + direction together. This file used to wrap
// MuiThemeProvider on its own; now it just delegates `isDarkMode`
// and `toggleDarkMode` to the SettingsContext so the existing
// consumers (Navbar, SideBar, DarkModeToggle) keep working unchanged.
//
// New code should call `useSettingsContext()` directly. This shim stays
// only until those three consumers are migrated in a later sprint.
import React from 'react';
import { SettingsProvider, useSettingsContext } from '../setting/SettingsContext';

export const useDarkMode = () => {
    const { themeMode, onToggleMode, onChangeMode } = useSettingsContext();
    return {
        isDarkMode: themeMode === 'dark',
        toggleDarkMode: onToggleMode,
        setDarkMode: (next) => onChangeMode(next ? 'dark' : 'light'),
    };
};

// Some App.jsx wiring still imports `DarkModeProvider`. Re-export
// `SettingsProvider` under the legacy name so existing imports keep
// working until App.jsx is updated.
export const DarkModeProvider = ({ children }) => (
    <SettingsProvider>{children}</SettingsProvider>
);
